import WarningOffset from './WarningOffset'
import FetchHelper from './FetchHelper'
import requestWakeLock from './../../../utils/wakeLock'
import {openFullscreen} from './../../../utils/fullscreen.js'
import {stopCamera} from './ImageProctor.js'


const beforeDestroy = (context) => {
    context.$store.commit('set_in_test',    false)
    context.$store.commit('toggle_toolbar', true)
    try {
      context.hangupVideoProctor()
      stopCamera()
      if(context.localStream) {
        context.localStream.getTracks().forEach((track) => track.stop())
        context.localStream = null
      }
    } catch(e){
      console.log(e)
    }
}

const onMount = (context) => {
  WarningOffset(context)
  FetchHelper(context)
  MarkInTest(context)
}

const MarkInTest = (context) => {
  context.$nextTick(() => {
    
    context.$store.commit('set_in_test',    true)
    context.$store.commit('toggle_toolbar', false)
    openFullscreen().catch(()=> context.showWarning = true)
    requestWakeLock()
  })
}

export default {onMount, beforeDestroy}